/* eslint-disable */
import { FIELD } from "@/data/constants";

export default [
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.FORM.ACTIONS,
    buttons: [
      {
        label: "Home",
        size: "large",
        appearance: "primary",
        action: "form:next"
      }
    ]
  }
];